import Trumpet from 'icons/home/trumpet.svg';
import { useEffect, useState, useContext } from 'react';
import { SiteContext, UserContext } from 'libs/contexts';
import { useRouter } from 'next/router';
import { CAROUSEL_AUTOPLAY_SPEED } from 'libs/cons';
import { Carousel } from 'antd';

/**
 * BulletinV2组件用于渲染公告项，展示公告标题和相关链接。
 * @param {Object} ev - 公告信息对象。
 */
var BulletinV2 = ({ ev }: any) => {
  const site = useContext(SiteContext);
  const userInfo = useContext(UserContext);
  const router = useRouter();
  const [retUrl, setRetUrl] = useState('');
  useEffect(() => {
    // 直接使用 location.href 获取完整的当前URL，更简单可靠
    setRetUrl(location.href);
  }, [router.asPath]);

  return (
    <div className="event-item-notice" key={`event-${ev.sysNo}`}>
      <div className="left">
        {/* 根据是否为新公告渲染不同样式 */}
        {/* <div className={cls('dot', ev.newFlag && 'newdot')} /> */}
        {/* 根据用户是否登录渲染不同的链接 */}
        <a
          rel="noreferrer"
          target="_blank"
          title={ev?.title}
          className="link"
          onClick={() => {
            const url = userInfo
              ? `/bulletin/${ev.sysNo}`
              : `/sso/login?return_url=${encodeURIComponent(retUrl)}`;
            window.selfOpen(url);
          }}
        >
          {ev.title}
        </a>
      </div>
      <style jsx>{`
        .event-item-notice {
          display: flex;
          overflow: hidden;
          padding: 5px 0;
        }

        .left {
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 22px;
          width: 100%;
        }

        .new {
          width: 37px;
          height: 20px;
          background: rgba(255, 119, 35, 0.1);
          border-radius: 3px;
          color: #FF7723;
          display: inline-flex;
          font-size: 12px;
          flex-shrink: 0;
          justify-content: center;
          align-items: center;
          margin-right: 4px;
        }
        .link {
          margin-right: 4px;
          color: inherit;
          flex: 1;
          overflow: hidden;
          white-space: nowrap; 
          text-overflow: ellipsis;
          color: #191919;
          font-size: 16px;
        }
        .link:hover {
          color: var(--primaryColor);
        }
        .left:hover .dot {
          background: var(--primaryColor);
        }
        .dot {
          border-radius: 100%;
          background: #D9D9D9;
          width: 6px;
          height: 6px;
          flex-shrink: 0;
          line-height: 18px;
          margin-right: 4px;
        }
        .newdot {
          background-color: #FF7723;
        }
        .event-item-notice:hover .dot {
          background: ${site?.global?.platformMainColor};
        }
      `}</style>
    </div>
  );
};
export default function MallNews({ bulletinData }) {
  const carouselSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    dotPosition: 'right' as const,
    autoplaySpeed: CAROUSEL_AUTOPLAY_SPEED,
  };
  return (
    <div className="news-box">
      <div className="left">
      <Trumpet />
        <span className="text">平台动态</span>
    </div>
    <Carousel {...carouselSettings}>
      {bulletinData && bulletinData.length
        ? bulletinData.map((ev) => <BulletinV2 key={ev.sysNo} ev={ev} />)
        : ''}
    </Carousel>
    {/* <div className='right'>
      了解更多
      <span className="arrow-icon">
        <ArrowIcon />
      </span>
    </div> */}
    <style jsx>{`
      .news-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        padding: 16px 24px;
        border-radius: 8px;
        margin-top: 20px;
        background: #fff;
      }
      .left {
        flex: none;
        display: flex;
        align-items: center;
      }
      .text {
        margin-left: 10px;
        margin-right: 28px;
        padding-right: 28px;
        line-height: 18px;
        border-right: 1px solid #D9D9D9;
      }
    `}</style>
  </div>
  );
}
